<template>
  <div>
    <v-row>
      <v-col>
        <v-sheet elevation="0" style="overflow-y: auto; height: 300px;">
          <Attachment
            v-for="(item, index) in ticket.attachments"
            :id="item.id"
            :fileName="item.fileName"
            :thumbFileName="item.thumbFileName"
            :description="item.description"
            :createdBy="item.authorUsername"
            :createdAt="item.createdAt"
            :key="item.id"
          >
          </Attachment>
          <div
            v-if="ticket.attachments && ticket.attachments.length === 0"
            class="pa-3"
            style="background-color: #424242; color: white; text-align: center;"
          >
            NO ATTACHMENTS
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Attachment from './Attachment.vue'

export default {
  components: {
    Attachment,
  },

  props: {
    ticket: Object,
  },
};

</script>
